import http from "../../../http-common"
class RegulatoryFocusFeatureFocusServices {
    getAllRegulatoryFocusFeatureFocus() {
        return http.get('/regulatory-focus/feature-focus')
    }
}

export default new RegulatoryFocusFeatureFocusServices();